import axios from "axios";
import {
    SUBSCRIBE_REQUEST,
    SUBSCRIBE_SUCCESS,
    SUBSCRIBE_FAIL,
} from "../constants/subscribersConstants";
import { hrmsBaseUrl } from "../shared/baseUrl";

export const createSubscribeRequest =
  (name, email, phone, company, designation) => async (dispatch) => {
    try {
      dispatch({
        type: SUBSCRIBE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      await axios.post(
        hrmsBaseUrl + "/api/v1/subscribers",
        {
            name, 
            email, 
            phone, 
            company, 
            designation
        },
        config
      );

      dispatch({
        type: SUBSCRIBE_SUCCESS,
        success: true,
      });
    } catch (error) {
      dispatch({
        type: SUBSCRIBE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
